import React from 'react'

const PartnerScorecardContext = React.createContext({error: null, hasResults: false, loading: true, results: null})
PartnerScorecardContext.displayName = 'PartnerScorecardContext'

export default PartnerScorecardContext
